import script from "./change.vue?vue&type=script&setup=true&lang=js"
export * from "./change.vue?vue&type=script&setup=true&lang=js"

import "./change.vue?vue&type=style&index=0&id=17571dee&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17571dee"]])

export default __exports__